<template>
  <div v-if="appointments.length > 0">
    <template
      v-for="date in Object.keys(appointmentByDate)"
      :key="date"
    >
      <h3>{{ getDate(date) }}</h3>
      <appointment-component
        v-for="appointment in appointmentByDate[date]"
        :key="appointment.id"
        :appointment="appointment"
        @update="onUpdate(appointment)"
      />
    </template>
  </div>
  <div v-else>
    {{ $t('appointmentspage.noappointmentfound') }}
  </div>
</template>

<script>
import AppointmentComponent from '@/components/appointments/AppointmentComponent'
import {convertDateStringToDayLocaleString} from "@/shared/utils/dateTimeUtils";

export default {
  name: 'AppointmentListComponent',
  components: { AppointmentComponent },
  props: {
    appointments: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update'],
  data() {
    return {
      passedByAppointmentId: {},
    }
  },
  computed: {
    appointmentByDate() {
      return this.appointmentsByDate(this.appointments)
    }
  },

  methods: {
    getDate(date) {
      return convertDateStringToDayLocaleString(date, this.$i18n.locale)
    },
    appointmentsByDate(appointments) {
      const result = {}
      for (const appointment of appointments) {
        const date = appointment.start.split('T')[0]
        if (!result[date]) {
          result[date] = []
        }
        result[date].push(appointment)
      }
      return result
    },
    onUpdate(appointment) {
      this.$emit('update', appointment)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
